import {
  ADD_STATE_FAIL,
  ADD_STATE_SUCCESS,
  ADD_STATE_REQUEST,
  DELETE_STATE_REQUEST,
  DELETE_STATE_SUCCESS,
  GETDETAIL_STATE_REQUEST,
  GETDETAIL_STATE_FAIL,
  GETDETAIL_STATE_SUCCESS,
  UPDATE_STATE_FAIL,
  UPDATE_STATE_SUCCESS,
  UPDATE_STATE_REQUEST,
  DELETE_STATE_FAIL,
  GETALL_STATE_FAIL,
  GETALL_STATE_SUCCESS,
  GETALL_STATE_REQUEST,
} from "../constant/StateConstant";

const initialState = {
  loading: false,
  action: "State",
  result: [],
  success: false,
  singledata: [],
  message: "",
  error: "",
};

const StateReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_STATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data,
        message: action.message,
      };
    case GETALL_STATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case GETDETAIL_STATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETDETAIL_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GETDETAIL_STATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case ADD_STATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_STATE_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_STATE_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case UPDATE_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),

        message: action.message,
      };
    case UPDATE_STATE_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,

        message: action.message,
      };

    case DELETE_STATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_STATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    default:
      return state;
  }
};

export default StateReducer;
